module.exports = "/_next/static/images/game-2-intro-tutorial-paper-ed6f3b7e0822bc44688961134cb04b52.png";